import React, { Fragment } from "react";

import Typography from "@mui/material/Typography";
import { Zoom } from "@mui/material";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";

import { ReactComponent as PlayIcon } from "../../../static/svg/play-btn.svg";
import { Link, useHistory, useLocation } from "react-router-dom";
import { ItemList } from "../../../models/resources.interface";

export type CardProps = {
  cardClass: string;
  iconClass: string;
  createdDate?: string | undefined;
  releaseDate?: string | undefined;
  length?: string;
  imageSrc: string | undefined;
  podTop?: string;
  top?: string | any;
  season?: string;
  episode?: string;
  title: string | undefined;
  text?: string | undefined;
  category?: ItemList[] | undefined;
  venue?: string | undefined;
  eventType?: string | undefined;
  imgBg: string;
  bodyBg: string;
  titleUrl: string;
  playUrl: string;
};

const ResCard = (props: CardProps) => {
  const history = useHistory();

  const formattedLength = React.useMemo(() => {
    if (!props.length) return "";

    const value = Number(props.length);

    const mins = Math.floor(value);
    const secs = Math.round((value - mins) * 100);

    if (mins < 60) {
      return secs > 0 ? `${mins} mins ${secs} secs` : `${mins} mins`;
    }

    const hrs = Math.floor(mins / 60);
    const remainingMins = mins % 60;

    return secs > 0
      ? `${hrs} hr ${remainingMins} mins ${secs} secs`
      : `${hrs} hr ${remainingMins} mins`;
  }, [props.length]);

  // console.log("object", props);
  return (
    <Fragment>
      <Box
        className="no-underline cursor-pointer"
        onClick={() => history.push(props.titleUrl)}
      >
        <Zoom in style={{ transitionDelay: "300ms" }}>
          <Card className={`${props.cardClass}`}>
            <CardMedia
              className={props.imgBg}
              component="img"
              image={props.imageSrc}
              alt="Resource Image"
            />
            <Link to={props.playUrl} className="no-underline">
              <PlayIcon className={`${props.iconClass} cursor-pointer`} />
            </Link>
            <CardContent className={`${props.bodyBg}`}>
              <Typography
                className="text-[11px] py-1 text-left font-areaExt uppercase text-navy-900"
                gutterBottom
                variant="h5"
                component="p"
              >
                {props.top}
              </Typography>
              <div className={`${props.podTop}`}>
                <Typography
                  className="text-[11px] text-start py-1 font-areaExt uppercase text-navy-900"
                  // gutterBottom
                  variant="h5"
                  // component="p"
                >
                  {/* Episode {props.season}:{props.episode} */}
                  {props.episode && "Episode " + props.episode}
                </Typography>
              </div>
              <Typography
                className="text-sm capitalize font-areaBold line-clamp-1 text-left text-navy-900"
                variant="body2"
                color="text.secondary"
              >
                {props.title}
              </Typography>

              {props.text ? (
                <Typography
                  className="text-xs h-auto text-start capitalize line-clamp-1 leading-[22px] font-areaSemi text-navy-900 opacity-50"
                  variant="body2"
                  color="text.secondary"
                >
                  {props.text}
                </Typography>
              ) : null}
            </CardContent>
            <hr className="w-[90%] mx-auto bg-navy-900 opacity-10 " />

            <CardActions
              className={`${props.bodyBg} text-xs -mt-2 text-navy-100`}
            >
              {props.category ? (
                <div
                  className="text-xs capitalize p-2 truncate text-navy-900 font-areaSemi"
                  // size="small"
                  // disabled
                >
                  {props.category.map((item) => item.interestName).join(", ")}
                </div>
              ) : null}

              {props.eventType && (
                <Box display={"flex"} p={1} gap={1} alignContent="center">
                  {props.eventType ? (
                    <Typography
                      className="text-xs h-10 text-start capitalize line-clamp-1 leading-[22px] font-areaSemi text-navy-900 opacity-50"
                      variant="body2"
                      color="text.secondary"
                    >
                      {props.eventType}
                    </Typography>
                  ) : null}

                  {props.eventType && props.venue ? "•" : ""}

                  {props.venue ? (
                    <Typography
                      className="text-xs h-10 text-start capitalize italic line-clamp-1 leading-[22px] font-areaSemi text-navy-900 opacity-50"
                      variant="body2"
                      color="text.secondary"
                    >
                      {props.venue}
                    </Typography>
                  ) : null}
                </Box>
              )}
              <Box display="flex" pl={1} gap={1} alignItems="center">
                {props.releaseDate ? (
                  <Typography
                    className="text-[11px] italic py-2 text-start text-navy-900"
                    variant="subtitle1"
                    color="text.secondary"
                  >
                    {props.releaseDate}
                  </Typography>
                ) : null}

                {props.length && (
                  <Typography
                    className="text-xs text-start capitalize line-clamp-1 leading-[22px] text-navy-900 opacity-50"
                    variant="subtitle2"
                  >
                    • {formattedLength}
                  </Typography>
                )}
              </Box>
            </CardActions>
          </Card>
        </Zoom>
      </Box>
    </Fragment>
  );
};

export default ResCard;
